import styled from 'styled-components';
import { Card } from 'react-bootstrap';
import { ChevronRight } from 'react-bootstrap-icons';
import { theme } from '../../../../theme';

const { colors, filters } = theme;

export const H4GroupName = styled.h4`
  margin-bottom: 1.7rem;
  color: ${colors.secondary};
  position: relative;

  &:after {
    content: '';
    position: absolute;
    bottom: -1rem;
    left: 0;
    width: calc(100% + 20px);
    height: 1px;
    background-color: ${colors.secondary};
  }
`;

export const AccordionCard = styled(Card)`
  &.filter-card {
    border: none;
    padding-right: 20px;
  }
  &.group-card {
    margin-bottom: 1.7rem !important;
  }
`;

export const AccordionCardHeader = styled(Card.Header)`
  &.filter-card-header {
    cursor: pointer;
    padding: 0;
    margin: 0;
    background-color: transparent;
    border: 0;
  }
`;

export const AccordionChevronRight = styled(ChevronRight)`
  color: ${filters.lightBlue3};
`;

export const AccordionCardTitle = styled(Card.Title)`
  &.filter-card-title {
    position: relative;
    margin: 0;
    padding: 8.5px 0 !important;
    font-size: 12px !important;
    line-height: 18px;
    color: ${filters.darkBlue2} !important;
    display: flex;
    justify-content: space-between !important;
    align-items: center;
  }

  &.is-collapsed {
    ${AccordionChevronRight} {
      transform: rotate(90deg);
      color: ${colors.primary};
    }
  }
`;

export const DivCollapse = styled.div`
  display: none;

  &.show {
    display: block;
  }
`;

export const DivCategoryFilter = styled.div`
  padding: 0 10px;
`;
